import React, { useState, useEffect, useContext, useRef } from 'react'
import glukyService from '../../services/glukyService'
import GlukyPage from '../../pages/Gluky/index'
import { Context } from '../../context/Contex'

function defaultFormValue() {
  return {
    linea: '',
    puntos: '',
  }
}

const GlukyContainer = () => {
  const [lines, setLines] = useState([])
  const [points, setPoints] = useState('')
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState(defaultFormValue())

  const { permisos } = useContext(Context)
  const timerToClearSomewhere = useRef(null)

  /*= =======================================================================
  Get  Lines
========================================================================= */

  const getLines = () => {
    setLoading(true)
    glukyService
      .getLines()
      .then((response) => {
        setLoading(false)
        setLines(response.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  /*= =======================================================================
  Get  Points
====================================================== ================== */
  const getPoints = () => {
    glukyService
      .getPoints()
      .then((response) => {
        setLoading(false)
        setPoints(response.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    setLoading(true)
    getLines()
    getPoints()
  }, [])

  /*= =======================================================================
  Get  handleCreate
====================================================== ================== */

  const handleCreate = (event) => {
    event.preventDefault()
    glukyService
      .postPoints(state)
      .then((response) => {
        if (response.data.id === 0) {
          setOpen(!open)
        } else {
          getPoints()
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
  /*= =======================================================================
Update Points
====================================================== ================== */

  const handleUpdate = (body) => {
    glukyService
      .putPoints(body)
      .then(() => {
        getPoints()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  /*= =======================================================================
  handleDeltete
====================================================== ================== */
  const handleDelete = (params) => {
    glukyService
      .deletePoints(params)
      .then(() => {
        getPoints()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    timerToClearSomewhere.current = setInterval(() => setOpen(false), 2000)
    return () => {
      clearInterval(timerToClearSomewhere.current)
    }
  }, [])

  const flatProps = {
    options:
      Array.isArray(lines) && lines.map((option) => option?.LINEA || 'vacia'),
  }

  const onChange = (event, type) => {
    setState({ ...state, [type]: event })
  }

  const columns = [
    { title: 'Linea', field: 'linea', editable: 'never' },
    { title: 'Puntos', field: 'puntos', type: 'numeric' },
    { title: 'Creacion', field: 'creacion', editable: 'never' },
    { title: 'Actualizacion', field: 'actualizacion', editable: 'never' },
  ]

  return (
    <>
      <GlukyPage
        open={open}
        points={points}
        columns={columns}
        lines={flatProps}
        loading={loading}
        permisos={permisos}
        onChange={onChange}
        handleCreate={handleCreate}
        handleUpdate={handleUpdate}
        handleDelete={handleDelete}
      />
    </>
  )
}

export default GlukyContainer
